// 导航
const state = {
  content: {
    // 导航列表
    nav_list: []
  }
};

const mutations = {
  SET_CONTENT(state, payload) {
    state.content = payload;
  }
};

const actions = {
  // 动态设置内容
  setContent({ commit }, content) {
    commit('SET_CONTENT', content);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/nav/index.js